// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  height: 100%;\n}\nbody {\n  font-size: 16px;\n}\n@media screen and (min-width: 780px) {\n#app {\n    width: 780px;\n    margin: 0 auto;\n}\nhtml,\n  body {\n    font-size: 78px !important;\n}\n}\n#nav {\n  padding: 30px;\n}\n#nav a {\n  font-weight: bold;\n  color: #2c3e50;\n}\n#nav a.router-link-exact-active {\n  color: #42b983;\n}", ""]);
// Exports
module.exports = exports;
